module.exports = __webpack_public_path__ + "static/media/feature_faster.00645470.png";